export const NOTIFICATION_STATUSES = {
  NONE: 'none',
  INFO: 'info',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning'
};
//# sourceMappingURL=consts.js.map